import React from 'react';
import ReactDOM from 'react-dom';
import App from 'core/App';
import 'izee-components/src/styles/_all.scss';
import 'izee-app/src/assets/css/izee_app.css';

ReactDOM.render(<App />,document.getElementById('root'));
